// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.nhraVideoBlockPlayer = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			playingIdValue: 'playing',
			playingId: '#playing',
			wrapper: '.video-player-block',
			myPlayerId: '#myPlayerID',
			thePlayer: document.getElementById('myPlayerID'),
			linkOverlayId: '#linkOverlay',
			adIsPlaying: false,
			manuallyPaused: false,
			initialLoad: true,
			videoObject: {type:"video", title: "", descripton: "", poster: "", videoUrl: "" },
			overlayClickUrl: ""
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		var _currentVideoId = $('[data-current-bcvid]:first').data('current-bcvid'),
			$wrapper = $(settings.wrapper),
			featuredMarkUp = '',
			myPlayer;

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		methods.videojsReady = function($context) {

			videojs(settings.myPlayerId).on('loadedmetadata',function(){
				methods.setOgMeta($context);
				settings.adIsPlaying = false;
			});

			videojs(settings.myPlayerId).ready(function(){
				myPlayer = this;
				myPlayer.muted(true);
				myPlayer.playlist.repeat(true);

				// Trigger esc key via close button
				$('.vjs-close-button.vjs-controlv.js-button').on( 'click', function() {
				var esc = $.Event("keydown", { keyCode: 27 });
				$("body").trigger(esc);
			});

			// Remove # fragment from share url
			$('.vjs-modal-dialog-content').on('mouseenter touchstart', function() {
				$('#myPlayerID > div.vjs-social-overlay.vjs-modal-dialog > div > form > label.vjs-social-direct-link > input[type="text"]').val(function(index, currentValue) {
					return currentValue.replace(/nhra#[a-zA-Z\-]*/g, 'nhra');
				});

				//Remove # fragment (%23) from share url
				$('.vjs-social-share-links > a').each( function() {
					var href = this.href;
					var Xhref = href.replace(/nhra%23[a-zA-Z\-]*/g, 'nhra');
					$(this).attr('href', Xhref);
				});
			});

			if(0 == $(settings.linkOverlayId).length ){
				//$('.vjs-big-play-button').css('z-index', '5');
				//$(settings.myPlayerId).find('.vjs-control-bar').before('<div id="linkOverlay"></div>');
				$(settings.myPlayerId).find('.vjs-poster').before('<div id="linkOverlay"></div>');
				//$('#myPlayerID').prepend('<div id="linkOverlay" class="has-share-drop"><div class="share-menu"></div></div>');

				$(settings.linkOverlayId, ".vjs-big-play-button").on('mouseenter touchstart', function(){

					methods.setOgMeta($context);

					var nhraPreRoll = '';
					var currentSrc = videojs('myPlayerID').currentSrc();
					var isNhraPreRoll = currentSrc == nhraPreRoll;

					var title = settings.videoObject.title;
					var videoUrl = settings.overlayClickUrl = settings.videoObject.videoUrl;
					var tags = videojs('myPlayerID').mediainfo.tags;
					var hashTags = [];

					$.each(tags, function(index, value){
						hashTags.push(value.replace(/ /g , '_'));
					});
					jsSocials.setDefaults("twitter", {
						via: "nhra",
						hashtags: hashTags
					});

					$context.find('.share-menu').jsSocials({
						showLabel: false,
						showCount: false,
						shareIn: "popup",
						shares: ["facebook","twitter","email"],
						text: title,
						url: videoUrl
					});

					$context.find('.share-menu').append('<p style="color: #fff; padding: 3px; background-color: rgba(0, 0, 0, 0.6);">' + title + '</p>');
					$context.find('.share-menu').fadeIn('300');

					$('#myPlayerID').removeClass('not-hover').removeClass('vjs-user-inactive');
				});

				$(".vjs-big-play-button").off("click").on("click", function(e){
					methods.setOgMeta($context);
					myPlayer.pause();
					// remove ad
					$('.vjs-ima3-ad-container').hide();

					location.href = settings.videoObject.videoUrl;
				});
			}

				// alter playlist to trigger "duringplaylistchange" event to access shuffle feature.
				videojs(settings.myPlayerId).on("beforeplaylistitem", function() {
						//var myPlayer = this;
						//myPlayer.playlist.currentIndex(1);
						//myPlayer.playlist.currentItem(1);
						//$(settings.linkOverlayId).show();

						//myPlayer.on("duringplaylistchange", function() {
						//	myPlayer.playlist.shuffle();
						//});
				});

			});
		}

		methods.checkIfVideoInView = function($context){

			if(!(settings.adIsPlaying || settings.manuallyPaused) || settings.initialLoad) {//Check if ad is playing

					$(settings.linkOverlayId).show();
					methods.setOgMeta($context);
					
					videojs(settings.myPlayerId).ready(function(){
						var myPlayer = this;
						 // the player is loaded
						if (methods.isScrolledIntoView(settings.thePlayer) && myPlayer && !settings.initialLoad) {
							//initialPause = false;
							// the player is fully in the viewport
							myPlayer.volume(.5);
							myPlayer.play();
							settings.initialLoad = false;
						} else {
							// the player is not in the viewport
							myPlayer.volume(0); 
							myPlayer.pause();
						}
					});
				}
		}

		methods.isScrolledIntoView = function(elem){
				var docViewTop = $(window).scrollTop(); 
				var docViewBottom = docViewTop + $(window).height(); 
				// get the position of the player element 

				var elemTop = $(elem).offset().top; 
				var elemBottom = elemTop + ($(elem).height() / 2); 
				// determine if the player element is in fully in the viewport //

				return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (elemTop >= docViewTop)); 
		}

		methods.adsLoad = function($context){
			videojs("myPlayerID").on('ads-load',function(){
					var myPlayer = this;
					settings.adIsPlaying = true;
					myPlayer.pause();
					$(settings.linkOverlayId).hide();
			});
		}

		methods.adsAdEnded = function($context){
			videojs("myPlayerID").on('ads-ad-ended',function(){
				settings.adIsPlaying = false;
				methods.setOgMeta($context);
			});
		}

		methods.setOgMeta = function($context){
			
			settings.adIsPlaying = false;
			var videoTitle = videojs('myPlayerID').mediainfo.name;
			if($('meta[property="og:title"]').length > 0) {
				$('meta[property="og:title"]').attr('content', videoTitle );
			} else { 
				$('head').append( '<meta property="og:title" content="'+ videoTitle +'"/>' );
			}
			settings.videoObject.title = videoTitle;

			var videoImage = videojs('myPlayerID').mediainfo.poster;
			if($('meta[property="og:image"]').length > 0) {
				$('meta[property="og:image"]').attr('content', videoImage );
			} else { 
				$('head').append( '<meta property="og:image" content="'+ videoImage +'"/>' );
			}
			settings.videoObject.poster = videoImage;

			var videoUrl = location.protocol + '//' + location.host + '/video/' + videojs('myPlayerID').mediainfo.id;
			settings.videoObject.videoUrl = videoUrl;
			$('meta[property="og:url"]').attr('content', videoUrl);

			$('meta[property="og:video"]').remove();
			$('head').append( '<meta property="og:video" content="' + videoUrl + '"/>' );

			if($('meta[property="og:description"]').length > 0) {
				$('meta[property="og:description"]').attr('content', 'Video: ' + videoTitle );
			} else { 
				$('head').append( '<meta property="og:description" content="Video: ' + videoTitle + '"/>' );
			}

			if($('meta[property="og:type"]').length > 0) {
				$('meta[property="og:type"]').attr('content', 'video' );
			} else { 
				$('head').append( '<meta property="og:type" content="video" />' );
			}
			console.log("OG meta set.......................");
		}


		// On load function
		methods.initContext = function($context) {
			$("#videoPlayer").parent().parent().css({padding: "0"});
			methods.setCurrentSettings($context);
			methods.videojsReady($context);
			methods.adsLoad($context);
			methods.adsAdEnded($context);
			methods.setOgMeta($context);

			$(window).scroll(function (){
				methods.checkIfVideoInView($context);
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));
